var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });

// src/posthog/deferred-instrumentation.ts
import { logger } from "@infra/logger";
import {
  scheduleAfterIdleOrInteraction
} from "../idle-start.js";
import { isPostHogConfigured } from "./config.js";
var POSTHOG_START_DELAY_MS = 0;
function initPostHogBrowserWhenIdle(options, schedule = {}) {
  if (!isPostHogConfigured()) {
    return () => void 0;
  }
  return scheduleAfterIdleOrInteraction(
    () => {
      void import("./instrumentation.js").then(({ initPostHogBrowser }) => initPostHogBrowser(
      options)).catch((error) => {
        logger.warn("PostHog failed to start", {
          error: String(error),
          appName: options.appName
        });
      });
    },
    { fallbackMs: POSTHOG_START_DELAY_MS, ...schedule }
  );
}
__name(initPostHogBrowserWhenIdle, "initPostHogBrowserWhenIdle");
export {
  POSTHOG_START_DELAY_MS,
  initPostHogBrowserWhenIdle
};
